module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.3e1b2a6.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-brands-400.woff2
// module id = 333
// module chunks = 1